import React, { useCallback, useMemo } from "react";
import { Card } from "..";
import { Grid, Box, Tab } from "@mui/material";
import { useHistory } from "react-router-dom";

import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

// Move grouping function outside component
const groupPrograms = (programs = []) => {
  const groups = {};

  if (!Array.isArray(programs)) return groups;

  programs.forEach((program) => {
    let groupName;
    const yearMatch = program?.programName?.match(/^(\d{4})/);
    const hkMatch = program?.programName?.match(/^(HK)/);
    const auMatch = program?.programName?.match(/^(AU \d{4} T\d)/);

    if (yearMatch) groupName = yearMatch[1];
    else if (hkMatch) groupName = "HK";
    else if (auMatch) groupName = auMatch[1];
    else groupName = "Other";

    if (!groups[groupName]) groups[groupName] = [];
    groups[groupName].push(program);
  });

  return groups;
};

const ProgramTabs = ({ programData }) => {
  const [tabValue, setTabValue] = React.useState("0");
  const history = useHistory();

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const viewAssessments = useCallback(
    (program) => {
      history.push(`/program-assessments/${program.programName}`, {
        programCards: program.programCards,
        programName: program.programName,
      });
    },
    [history]
  );
  const groupedPrograms = useMemo(
    () => groupPrograms(programData),
    [programData]
  );
  if (!programData || !programData.length) return null;
  const groups = Object.entries(groupedPrograms);
  return (
    <Box
      sx={{
        width: "100%",
        typography: "body1",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <TabContext value={tabValue}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            borderBottom: 1,
            borderColor: "divider",
            mb: 3,
          }}
        >
          <TabList
            onChange={handleTabChange}
            aria-label="program groups"
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              "& .MuiTabs-flexContainer": {
                gap: 3,
                justifyContent: "center",
              },
            }}
          >
            {groups.map(([groupName], index) => (
              <Tab
                key={groupName}
                label={groupName}
                value={index.toString()}
                sx={{
                  textTransform: "none",
                  fontSize: "0.875rem",
                  fontWeight: 600,
                  minWidth: "unset",
                  px: 2,
                  py: 1,
                  borderRadius: "25px",
                  border: "1px solid #233062",
                  borderColor: "divider",
                  backgroundColor: "background.paper",
                  marginBottom: "20px",
                  color: "text.secondary",
                  "&.Mui-selected": {
                    color: "#233062",
                    backgroundColor: "#fff",
                    borderColor: "#233062",
                  },
                  "&:hover": {
                    backgroundColor: "action.hover",
                  },
                  transition: "all 0.2s ease",
                }}
              />
            ))}
          </TabList>
        </Box>
        {groups.map(([groupName, programs], index) => (
          <TabPanel
            key={groupName}
            value={index.toString()}
            sx={{
              width: "100%",
              p: 3,
            }}
          >
            <Grid container spacing={3}>
              {programs.map((program) => (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={4}
                  lg={4}
                  key={program.programName}
                >
                  <Card
                    btnText="View Assessment"
                    cardTitle={program.programName}
                    btn
                    fullTitle
                    goToPlacement={() => viewAssessments(program)}
                  />
                </Grid>
              ))}
            </Grid>
          </TabPanel>
        ))}
      </TabContext>
    </Box>
  );
};

export default ProgramTabs;
